if (!customElements.get('cart-campaigns')) {
  customElements.define(
    'cart-campaigns',
    class CartCampaigns extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.lastCampaignProductVariantId = null;
        this.campaigns = {};
        this.activeCampaign = null;
        this.cartUpdated = false;
        this.prevCampaigns = this.querySelectorAll('.cart-campaign-block');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.checkCart();
      }
      cartUpdateUnsubscriber = undefined;

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          this.onCartUpdate(event);
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      async onCartUpdate(event) {
        if (event.source === 'product-form') {
          this.lastCampaignProductVariantId = event.productVariantId;
        }
        fetch(`${routes.cart_url}?section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('cart-campaigns');
            this.prevCampaigns = this.querySelectorAll('.cart-campaign-block');
            this.innerHTML = sourceQty.innerHTML;
          })
          .then(() => {
            this.updateCheckoutButtonState();
          })
          .then(() => {
            this.removeIneligibleGifts();
          })
          .then(() => {
            return this.checkCart();
          })
          .then((response) => {
            if (this.cartUpdated) {
              this.cartUpdated = false;
            } else {
              this.renderCartNotification(response);
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }

      renderCartNotification(parsedState) {
        let giftNoticeContainer = document.getElementById('gift-notice-container');
        const campaignProductElement = document.getElementById('cart-notification-product');
        if (!giftNoticeContainer) {
          const giftNoticeContainerHtml = `<div id="gift-notice-container"></div>`;
          campaignProductElement.insertAdjacentHTML('afterend', giftNoticeContainerHtml);
          giftNoticeContainer = document.getElementById('gift-notice-container');
        }
        let giftProductHtml = '';

        if (parsedState) {
          // Gift product has been added to cart, show related campaign info
          this.cart.getSectionsToRender().forEach((section) => {
            const itemKey = parsedState.items[0].key;
            const itemVariantId = parsedState.items[0].variant_id;
            if (!itemVariantId) return;
            const campaignItem = this.campaigns[itemVariantId];
            if (!campaignItem || campaignItem.show == false) return;
            const productSection = parsedState.sections['cart-notification-product'];
            const giftElem = new DOMParser().parseFromString(productSection, 'text/html');
            const selector = `[id="cart-notification-product-${itemKey}"]`;
            const productAddedToCartHeadingHtml = document.querySelector('.cart-notification__heading')?.outerHTML;
            giftProductHtml = productAddedToCartHeadingHtml + giftElem.querySelector(selector).outerHTML;
            this.cartUpdated = true;

            if (section.id != 'cart-notification-product') {
              const sectionInnerHTML = this.cart.getSectionInnerHTML(
                parsedState.sections[section.id],
                section.selector
              );
              document.getElementById(section.id).innerHTML = sectionInnerHTML;
            }
          });
        }

        if (this.activeCampaign?.show) {
          // Show campaign info for active campaigns, when not yet eligible for gift or prize selection is enabled
          const campaignUrl = this.activeCampaign.url;
          const campaignName = this.activeCampaign.name;
          const campaignInfo = this.activeCampaign.info;
          const campaignHeaderHtml = this.renderCampaignHeader(campaignUrl, campaignName);
          const campaignFooterHtml = this.renderCampaignFooter(campaignInfo);
          giftNoticeContainer.innerHTML = campaignHeaderHtml + giftProductHtml + campaignFooterHtml;
        }
      }

      renderCampaignHeader(campaignUrl, campaignName) {
        return `
        <hr style="margin: 0;">
        <h3 class="bxg1-h4 h4">
          <a
            style="text-decoration: none !important; margin: 0px; color: #484848 !important;"
            href="${campaignUrl}"
          >
            ${campaignName}
          </a>
        </h3>`;
      }
      renderCampaignFooter(campaignInfo) {
        return `
        <div
          class="panel text-small campaign-notice-container"
          >
          <div class="bxg1-notification">
            <p class="giftNotice">
              ${campaignInfo}
            </p>
          </div>
        </div>
        `;
      }

      async removeIneligibleGifts() {
        const campaignBlocks = this.querySelectorAll('.cart-campaign-block');

        if (this.prevCampaigns.length > campaignBlocks.length) {
          const prevGiftsArr = Array.from(this.prevCampaigns);
          const prevGiftsIdsData = prevGiftsArr.map((item) => item.dataset.campaignGiftVariantIds);
          const prevGiftsIds =
            prevGiftsIdsData
              .map((item) => item.split(','))
              ?.flat()
              ?.filter((arr) => arr) || [];
          const giftsIdsData = Array.from(campaignBlocks).map((item) => item.dataset.campaignGiftVariantIds);
          const giftIds =
            giftsIdsData
              .map((item) => item.split(','))
              ?.flat()
              ?.filter((arr) => arr) || [];
          const giftIdsSet = new Set(giftIds.map((number) => number));
          const giftIdsToRemove = prevGiftsIds.filter((number) => !giftIdsSet.has(number));
          if (giftIdsToRemove.length == 0) return;
          const cartData = await this.updateCart(null, 0, giftIdsToRemove);
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-campaigns', cartData: cartData });
        }
      }

      // Prevent prodeeding to checkout if ineligible gifts in cart
      updateCheckoutButtonState() {
        const checkoutButton = document.querySelector('#checkout');
        if (!checkoutButton) {
          return;
        }
        checkoutButton.disabled = !!document.querySelector('.warning-message');
      }

      async checkCart() {
        const campaignBlocks = this.querySelectorAll('.cart-campaign-block');
        let cartData;
        this.campaigns = {};
        this.activeCampaign = null;

        this.setCartAttributes();

        for (const campaignElem of campaignBlocks) {
          // If true, user will select prize manually from choices
          const prizeSelection = JSON.parse(campaignElem.dataset.prizeSelection);
          // Campaign name and url
          const campaignHeader = campaignElem.dataset.campaignHeader;
          const campaignUrl = campaignElem.dataset.campaignUrl;
          const campaignInfo = campaignElem.dataset.campaignInfo;
          const campaignName = campaignElem.dataset.campaignName;
          // Variant id and key of the prize product
          const giftVariantId = campaignElem.dataset.campaignGiftVariantId;

          const campaignsArr = Array.from(document.getElementsByName('campaign'));
          const activeCampaignName = campaignsArr.find(
            (item) => item.dataset.variantId == this.lastCampaignProductVariantId
          )?.dataset.campaignName;

          const campaignKey = prizeSelection ? 'selection' : giftVariantId;
          this.campaigns[campaignKey] = { name: campaignHeader, url: campaignUrl, info: campaignInfo, show: false };
          if (activeCampaignName == campaignName) {
            this.campaigns[campaignKey].show = true;
            this.activeCampaign = this.campaigns[campaignKey];
          }

          // How many gift products the user is eligible for
          const campaignEligibleAmount = parseInt(campaignElem.dataset.campaignEligibleAmount);
          // How many campaign prizes are in cart currently
          const prizesInCart = parseInt(campaignElem.dataset.campaignPrizesInCart);
          // How many prize products should be in cart
          let prizeQuantity = campaignEligibleAmount - prizesInCart;

          if (!prizeSelection && prizeQuantity > 0) {
            cartData = await this.addToCart(giftVariantId, prizeQuantity);
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-campaigns',
              cartData: cartData,
              variantId: giftVariantId,
            });
          } else if (!prizeSelection && prizeQuantity < 0) {
            prizeQuantity += prizesInCart;
            cartData = await this.updateCart(giftVariantId, prizeQuantity);
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-campaigns',
              cartData: cartData,
              variantId: giftVariantId,
            });
          } else if (prizeSelection && prizeQuantity < 0) {
            this.updateCheckoutButtonState();
          }
        }
        return cartData;
      }

      async setCartAttributes() {
        console.log("setCartAttributes");
        const st = document.getElementById("stamps-collected");
        if (st) { 
          await window.na.updateCartAttribute(st, "Orionin keräilyleimoja");
        }
      }
      
      async updateCart(id, quantity, ids = null) {
        let updates;
        if (ids) {
          updates = ids.reduce((a, v) => ({ ...a, [v]: 0 }), {});
        } else {
          updates = {
            [id]: quantity,
          };
        }

        let formData = JSON.stringify({ updates });
        if (this.cart) {
          const sections = this.cart.getSectionsToRender().map((section) => section.id);
          const sections_url = window.location.pathname;
          formData = JSON.stringify({ updates, sections, sections_url });
          this.cart.setActiveElement(document.activeElement);
        }

        return fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: formData,
        })
          .then((response) => {
            return response.json();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      }

      async addToCart(id, quantity) {
        const formData = { items: [{ id: id, quantity: quantity }] };
        if (this.cart) {
          formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
          formData.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }
        return fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            return response.json();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      }

      async getSections() {
        const formData = {};
        if (this.cart) {
          formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
          formData.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }
        return fetch(`${window.Shopify.routes.root}?sections=${formData.sections}`)
          .then((response) => response.json())
          .then((data) => {
            return data;
          });
      }

      async getCart() {
        return fetch(window.Shopify.routes.root + 'cart.js')
          .then((response) => response.json())
          .then((data) => {
            return data;
          });
      }
    }
  );
}
